





























import {Component, Vue, Watch} from "vue-property-decorator";
import {PickingListTranshipmentParams} from "../../../params";
import MillisecondDatePicker from "../../../../../shared/components/MillisecondDatePicker/index.vue";
import {PartnerType} from "@/enums/type";
import {PickingListTranshipmentStore} from "../../../store";
import { debounce } from 'lodash';
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {PickingListTranshipmentStatus} from "@/enums/status";

@Component({
    name: "ConfirmedPLTranshipmentSearch",
    components: {EnumSelector, PostOfficeSelector, PartnerSelector, MillisecondDatePicker}
})
export default class extends Vue {
    PartnerType = PartnerType;
    search = new PickingListTranshipmentParams();
    PickingListTranshipmentStatus = PickingListTranshipmentStatus;

    @Watch("search", { immediate: false, deep: true })
    onSearch(val: any, oldVal: any) {
        this.handleChangeSearch(val);
    }

    handleChangeSearch = debounce((val: any) => {
        PickingListTranshipmentStore.updatePickingListTranshipmentParams({ ...PickingListTranshipmentStore.params, ...val });
        PickingListTranshipmentStore.listConfirmedPickingListTranshipment({...PickingListTranshipmentStore.params, page: 1});
    }, 500)
}
